/**
 * DmMessageBubble
 * DM message bubble using shared MessageBubble component.
 * Adds edit/delete for own messages only.
 */

import { useTranslation } from "@/language"
import type { DmMessage } from "../../types/dm-chat.types"
import { MessageBubble } from "../shared/MessageBubble"

interface DmMessageBubbleProps {
  message: DmMessage
  isOwn: boolean
  senderId?: string | null
  senderName?: string | null
  senderPhoto?: string | null
  showSenderInfo?: boolean
  onEdit?: (message: DmMessage) => void
  onDelete?: (messageId: string) => void
}

export function DmMessageBubble({
  message,
  isOwn,
  senderId,
  senderName,
  senderPhoto,
  showSenderInfo,
  onEdit,
  onDelete,
}: DmMessageBubbleProps) {
  const { t } = useTranslation("chats")

  return (
    <MessageBubble
      content={message.content}
      isOwn={isOwn}
      isDeleted={message.isDeleted}
      deletedLabel={t("dmMessage.deleted")}
      senderId={senderId}
      senderName={senderName}
      senderPhoto={senderPhoto}
      showSenderInfo={showSenderInfo}
      onEdit={onEdit ? () => onEdit(message) : undefined}
      onDelete={onDelete ? () => onDelete(message.id) : undefined}
    />
  )
}
